import React from "react";
import "./Contact.css"; // Ton CSS si nécessaire
import Navbar from "./Navbar";

const ContactSection = () => {
  return (
    <div className="contact-section">
            <Navbar />
      <div className="contact-row">
        <div className="contact-column empty-col"></div>
        
        <div className="contact-column main-col">
          <div className="contact-icons">
            {/* Adresse */}
            <div className="contact-item">
              <div className="contact-icon">
                <svg width="24" height="24" viewBox="0 0 24 24">
                  <path d="M12,0.938c-3.87,0-7.375,3.137-7.375,7.008
                  c0,3.87,3.198,8.491,7.375,15.117c4.178-6.626,7.375-11.247,7.375-15.117C19.375,4.075,15.871,0.938,12,0.938z M12,11.078
                  c-1.528,0-2.766-1.238-2.766-2.766S10.472,5.547,12,5.547c1.527,0,2.766,1.238,2.766,2.766S13.527,11.078,12,11.078z"/>
                </svg>
              </div>
              <div className="contact-info">
                <span>Castilla Business Center</span>
                <span>8eme, Bureau CBC 39</span>
                <span>Av. Abderrahmane El Youssfi, Tanger 90060, Maroc</span>
              </div>
            </div>

            {/* Email */}
           {/* Email */}
          <div className="contact-item">
            <a href="mailto:qunci.immobilier@gmail.com" className="contact-link">
              <div className="contact-icon">
                <svg width="64" height="64" viewBox="0 0 24 24">
                  <path d="M0.456,3.342v17.316h23.088V3.342H0.456z M21.156,5.266L12,12.686
                  L2.844,5.266l9.153,7.306L21.156,5.266z"/>
                </svg>
              </div>
              <div className="contact-info">
                <span>qunci.immobilier@gmail.com</span>
              </div>
            </a>
          </div>


            {/* Téléphone */}
            <div className="contact-item">
              <div className="contact-icon">
                <svg width="24" height="24" viewBox="0 0 24 24">
                  <path d="M4.052,1.909l2.688-1.25l3.819,7.457L7.984,9.383
                  c-0.509,1.19,2.04,5.943,3.115,6.022c0.085-0.056,2.524-1.255,2.524-1.255l3.885,7.494c0,0-2.611,1.279-2.695,1.32
                  C7.381,26.357-3.241,5.71,4.052,1.909z"/>
                  <path d="M16.034,11.163c0.212-0.706,0.151-1.492-0.228-2.189
                  c-0.377-0.698-1.004-1.179-1.709-1.388"/>
                  <path d="M14.982,4.615c1.466,0.437,2.766,1.433,3.55,2.883
                  c0.784,1.452,0.907,3.084,0.471,4.548"/>
                  <path d="M15.88,1.604c2.235,0.667,4.218,2.185,5.414,4.4
                  c1.199,2.214,1.388,4.704,0.72,6.939"/>
                </svg>
              </div>
              <div className="contact-info">
                <span>+212 7 03 13 13 30</span>
              </div>
              <a href="tel:+212703131330" ></a>
            </div>

          </div>
        </div>

        <div className="contact-column empty-col"></div>
      </div>
    </div>
  );
};

export default ContactSection;
